import * as React from "react";
import {ValuableItem, ValuableItemTypeEnum, ValuableItemCoverLocation} from "@falcon/services";
import {ConfirmModal, calculateValuablesTotalValue} from "@falcon/plugin-falcon-journey";
import ValuableItemModal from "./ValuableItemModal";
import ImageUploadPanel from "./ImageUploadPanel";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {getAmountToDisplay} from "../../../../../CommonFunctions";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IProps {
    item: ValuableItem,
    interaction: any,
    cancelled: boolean
}

interface IState {
    showItemModal: boolean
    showRemoveConfirmation: boolean
    item: ValuableItem
}

export class ValuableItemPanelPlain extends React.Component<IProps & IWithRouterProps, IState> {

    constructor(props: IProps & IWithRouterProps) {
        super(props);

        this.state = {
            showItemModal: false,
            showRemoveConfirmation: false,
            item: this.props.item
        };
    }

    public render() {
        const valuableItems: ValuableItem[] = this.props.interaction.valuableItems;
        return (
            <>
                {this.renderItemPanel()}
                {this.state.showItemModal &&
                <ValuableItemModal {...this.props}
                                   show={this.state.showItemModal}
                                   hide={() => this.setState({showItemModal: false})}
                                   onConfirm={this.editItem}
                                   item={this.state.item}
                                   itemWordings={PluginTemplates.getSpecifiedItemWordings(this.state.item)}
                                   interactionId={this.props.interaction._id}
                                   totalValueOfItems={calculateValuablesTotalValue(valuableItems)}
                                   insuredValue={this.props.interaction.factors.insuredValue}/>}

                {this.state.showRemoveConfirmation &&
                <ConfirmModal show={this.state.showRemoveConfirmation}
                              onHide={() => this.setState({showRemoveConfirmation: false})}
                              onConfirm={() => this.removeItem(this.state.item!)}
                              confirmButtonText="Yes, please">
                    <div className="fs-20 font-weight-medium font-family-display">
                        Are you sure you want to remove this item from your cover?
                    </div>
                </ConfirmModal>}
            </>
        );
    }

    private renderItemPanel = (): React.ReactNode => {
        return (
            <div className="mt-2 p-3 bg-white-blue rounded">
                <div id={`specifiedItem-description-${this.state.item.valuableItemId}`}>{this.state.item.description}</div>
                <div>
                    <b>{this.state.item.coverLocation === ValuableItemCoverLocation.HOME ? "Cover inside the home" : "Cover inside and outside the home"}</b> for <b>£{this.state.item.value}</b>
                </div>
                <div>Monthly price: <b>{getAmountToDisplay(this.state.item.premium)}</b></div>
                {this.state.item.serialNumber &&
                    <div className="mt-2">
                        {this.state.item.valuableItemType === ValuableItemTypeEnum.MOBILE ? "IMEI" : "Serial"} number: <b className="word-break-all">{this.state.item.serialNumber}</b>
                    </div>}
                {!this.state.item.serialNumber && !this.props.cancelled &&
                    <div className="mt-2 font-weight-medium text-blue-1 text-decoration-underline">
                        <span onClick={() => this.setState({showItemModal: true})} className="mr-5 cursor-pointer">
                            Add {this.state.item.valuableItemType === ValuableItemTypeEnum.MOBILE ? "IMEI" : "serial"} number
                        </span>
                    </div>
                }
                <ImageUploadPanel item={this.state.item}/>
                {!this.props.cancelled &&
                    <div className="d-flex justify-content-between mt-2 font-weight-medium text-blue-1 text-decoration-underline">
                        <span onClick={() => this.setState({showItemModal: true})} className="mr-5 cursor-pointer" id={`edit-item-${this.props.item.valuableItemId}`}>
                            Edit
                        </span>
                        <span onClick={() => this.setState({showRemoveConfirmation: true})} className="cursor-pointer" id={`remove-item-${this.props.item.valuableItemId}`}>
                            Remove
                        </span>
                    </div>
                }
            </div>
        )
    };

    private removeItem = (item: ValuableItem): void => {
        window.sessionStorage.removeItem("itemToProcess");
        window.sessionStorage.setItem("itemToProcess", JSON.stringify(item));
        this.props.navigate(`/journey/show/product/RentersInsurance/process/mtaRemoveItem/preset/${this.props.interaction._id}`);
    };

    private editItem = (item: ValuableItem): void => {
        this.setState({showItemModal: false, item});
    };
}

export default withRouter<IProps>(ValuableItemPanelPlain)
